module.exports = __webpack_public_path__ + "img/hn.e4fc80ed.gif";